var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.6667C2.5 14.2985 2.79848 14 3.16667 14H13.8333C14.2015 14 14.5 14.2985 14.5 14.6667C14.5 15.0349 14.2015 15.3333 13.8333 15.3333H3.16667C2.79848 15.3333 2.5 15.0349 2.5 14.6667Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6381 2.08133C11.3777 1.82098 10.9556 1.82098 10.6953 2.08133L10.1095 2.6671L12.5 5.05762L13.0858 4.47185C13.3461 4.2115 13.3461 3.78939 13.0858 3.52905L11.6381 2.08133ZM5.1095 7.66709L9.16669 3.6099L11.5572 6.00043L7.50002 10.0576L5.1095 7.66709ZM4.16669 8.6099L3.83333 8.94326V11.3338H6.22386L6.55721 11.0004L4.16669 8.6099ZM9.75245 1.13852C10.5335 0.357472 11.7998 0.357472 12.5809 1.13852L14.0286 2.58624C14.8096 3.36729 14.8096 4.63362 14.0286 5.41466L7.16667 12.2766C6.91662 12.5266 6.57748 12.6671 6.22386 12.6671H3.83333C3.09695 12.6671 2.5 12.0702 2.5 11.3338V8.94326C2.5 8.58964 2.64048 8.2505 2.89052 8.00045L9.75245 1.13852Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1fae08e511159c04a380280108b92b67.svg";
export { ForwardRef as ReactComponent };